<template>
  <div class="showcard">
    <div class="card__inner">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "BlankCard",
  props: {
    card: Object,
  },
};
</script>
